import { render, staticRenderFns } from "./IconPencilAltSolid.vue?vue&type=template&id=6e7fed42"
import script from "./IconPencilAltSolid.vue?vue&type=script&lang=js"
export * from "./IconPencilAltSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports